import { getOPCO } from "../../../../Shared/helper/helper";
import customEventConfig from "../../Config/CustomEventConfig";
import { getUserDeviceId, getUserSessionId } from "../../../utills";

class CustomEventProvider {
  constructor() {
    this.name = "CUSTOM_EVENT"
    this.event = null
    this.userDeviceId = null
    this.userSessionId = null
    this.country = null
    this.date = new Date()
  }
  initialize() {
    this.event = (window)?.eventTrackerInit?.();
    const { channel, xCountry, eventBaseURL, isEnable, ...headerConfig } = customEventConfig

    if (isEnable && channel && xCountry && this.event) {
      this.event.initialize({
        eventBaseURL,
        channel,
        xCountry,
        header: headerConfig,
      });
      this.country = getOPCO();
      this.userDeviceId = getUserDeviceId();
      this.userSessionId = getUserSessionId();
      return true
    } else {
      return false
    }
  }
  execute(payload) {
    this.event?.send({
      timeStamp: this.date.toISOString(),
      iso_country_code: this.country,
      deviceId: this.userDeviceId,
      sessionId: this.userSessionId,
      ...payload
    });
  }
  track(eventPayload) {
    this.execute(eventPayload)
  }
  pageView(eventPayload) {
    this.execute(eventPayload)
  }
}

export default CustomEventProvider